module.exports = __webpack_public_path__ + "static/media/pk.52975d36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pk.svg
// module id = 223
// module chunks = 0